import axios from '@/api';

export function listChangelog(limit) {
    const params = {};

    if (limit != null) {
        params.limit = limit;
    }

    return axios.get('/changelog', { params });
}
